import type { UseMutationResult } from "@tanstack/react-query";
import { useMutation, useQueryClient } from "@tanstack/react-query";

import type { CompanyCard } from "app/pages/sales-intelligence/modules/company-analysis/types/company";
import salesApiService from "app/pages/sales-intelligence/services/salesApiService";

import { companyAnalysisQueryKeys } from "./queryKeyFactory";

export default function useEcommerceReportMutation(): UseMutationResult<void, void, string> {
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn(domain: string): Promise<void> {
            return salesApiService.companyAnalysis.reportECommerceOverview(domain);
        },
        retry: false,
        onSuccess: (_, domain) => {
            queryClient.setQueryData(companyAnalysisQueryKeys.companyCard(domain), (queryData: CompanyCard) => {
                return { ...queryData, isReported: true };
            });
        },
        throwOnError: true,
    });
}
